import React, { useState } from "react";
import { Box, Button, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FONT_SIZE } from "../../constants/fontSizes";

/**
 * 下部ボタンで開閉する共通セクション
 */
const ExpandableSection = ({
  collapsedContent,
  expandedContent,
  summaryText = "もっと見る",
  closeText = "閉じる",
  defaultExpanded = false,
  showButton = true,
  expandedSpacing = 0,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Box>
      {/* 常に表示される部分（折りたたみ時） */}
      {collapsedContent}

      {/* 展開時に追加で表示される部分 */}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Box sx={{ mt: expandedSpacing }}>{expandedContent}</Box>
      </Collapse>

      {/* 下部ボタン */}
      {showButton && (
        <Box mt={1}>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => setExpanded((prev) => !prev)}
            sx={{
              borderRadius: 999,
              py: 1,
              fontSize: FONT_SIZE.SM,
              textTransform: "none",

              color: "#6C73DD",
              borderColor: "#6C73DD",

              "&:hover": {
                backgroundColor: "rgba(108, 115, 221, 0.08)",
                borderColor: "#6C73DD",
              },
            }}
          >
            <Box
              sx={{
                width: "100%",
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* 中央テキスト */}
              <Box component="span" sx={{ fontWeight: "bold" }}>
                {expanded ? closeText : summaryText}
              </Box>

              {/* 右端アイコン */}
              <ExpandMoreIcon
                sx={{
                  position: "absolute",
                  right: 0,
                  color: "#6C73DD",
                  transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "0.2s",
                }}
              />
            </Box>
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ExpandableSection;
